export const CHECKIN_LOADING = 'CHECKIN_LOADING'
export const CHECKIN_COMPLETE = 'CHECKIN_COMPLETE'
export const CHECKIN_ERROR = 'CHECKIN_ERROR'



//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/checkin/mutation-types.js
// module id = null
// module chunks = 